import React from 'react'
import './App.less'
import Entry from './pages/entry'
import logo from "./static/image/logo.png"
import loginpage from "./static/image/loginpage.png"

function App() {
	return (
		<div className="App" style={{backgroundImage: `url(${loginpage})`}}>
			<div className="logo-img">
				<img src={logo} alt="" />
			</div>
			<Entry />
		</div>
	)
}

export default App
